"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumPowerPortGroupingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const project_1 = require("../../project");
const AltiumLabelTypeNameUtil_1 = require("./AltiumLabelTypeNameUtil");
const AltiumNetNameCaseSelection_1 = require("./AltiumNetNameCaseSelection");
class AltiumPowerPortGroupingRule {
    constructor(config) {
        this.config = config;
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
    }
    apply(manager, _hierarchy) {
        const globalScope = Symbol('global-power-port-scope');
        const powerGroupsByScopeAndName = new Map();
        const powerNamesByScopeAndFormattedName = new Map();
        const isStrictHierarchical = this.config.mode === project_1.HierarchyMode.StrictHierarchical;
        for (const group of manager.findGroupsWithLabel('power-port')) {
            for (const [instance, nets] of group.getNets()) {
                for (const net of nets) {
                    for (const label of net.labels) {
                        if (label.labelType !== 'power-port') {
                            continue;
                        }
                        const formattedLabel = label.formattedLabel;
                        if (formattedLabel === undefined) {
                            continue;
                        }
                        const scope = isStrictHierarchical ? instance : globalScope;
                        const name = formattedLabel.toLowerCase();
                        const authoredName = label.originalLabel.toLowerCase();
                        const formattedName = AltiumLabelTypeNameUtil_1.AltiumLabelTypeNameUtil.maybeDereferenceLabelName(formattedLabel);
                        const powerNames = powerNamesByScopeAndFormattedName.get(scope) ?? new Map();
                        if (formattedName.toLowerCase() === authoredName) {
                            powerNames.set(name, authoredName);
                        }
                        powerNamesByScopeAndFormattedName.set(scope, powerNames);
                        const names = powerGroupsByScopeAndName.get(scope) ?? new Map();
                        const groups = names.get(name) ?? new Set();
                        groups.add(group);
                        names.set(name, groups);
                        powerGroupsByScopeAndName.set(scope, names);
                    }
                }
            }
        }
        for (const [scope, groupsByName] of powerGroupsByScopeAndName) {
            for (const [name, powerGroups] of groupsByName) {
                const livePowerGroups = Array.from(new Set(Array.from(powerGroups).map((group) => manager.resolveGroup(group))));
                const [powerGroup] = livePowerGroups;
                if (powerGroup === undefined) {
                    continue;
                }
                manager.mergeGroups(...livePowerGroups);
                const powerName = powerNamesByScopeAndFormattedName.get(scope)?.get(name);
                if (powerName === undefined) {
                    continue;
                }
                if (typeof scope === 'symbol') {
                    this.mergeMatchingNetLabels(manager, powerGroup, powerName);
                }
                else if (this.config.appendSheetNumberToLocalNets) {
                    this.mergeMatchingNetLabels(manager, powerGroup, powerName, scope);
                }
            }
        }
        return manager;
    }
    mergeMatchingNetLabels(manager, powerGroup, caseFoldedPowerName, instance) {
        const matchedLabelNames = [];
        let absorbedNetLabelGroup = false;
        for (const group of manager.findGroupsWithLabel('net-label')) {
            const matchingNets = Array.from(group.getNets()).flatMap(([netInstance, nets]) => {
                if (instance !== undefined && netInstance !== instance) {
                    return [];
                }
                return nets.flatMap((net) => {
                    const matchingLabels = net.labels.filter((label) => label.labelType === 'net-label' && label.originalLabel.toLowerCase() === caseFoldedPowerName);
                    if (matchingLabels.length === 0) {
                        return [];
                    }
                    matchedLabelNames.push(...matchingLabels.map((label) => label.originalLabel));
                    return [[netInstance, net]];
                });
            });
            if (matchingNets.length === 0) {
                continue;
            }
            if (group !== powerGroup) {
                manager.moveNetsToGroup(powerGroup, group, matchingNets);
                absorbedNetLabelGroup = true;
            }
        }
        if (absorbedNetLabelGroup && matchedLabelNames.length > 0) {
            powerGroup.physicalName = matchedLabelNames.sort(AltiumNetNameCaseSelection_1.compareAltiumNetNameCaseVariants)[0];
        }
    }
}
exports.AltiumPowerPortGroupingRule = AltiumPowerPortGroupingRule;
//# sourceMappingURL=AltiumPowerPortGroupingRule.js.map